import { useCallback } from "react";

import {
  TagDeleteIcon,
  TagLabel,
  Typography,
  useComboBox,
} from "@aircall/tractor";

import { MultiSelectTagItemProps } from "./MultiSelectTagItem.decl";

import { TagBeautified } from "@/components/TagBeautified";

export function MultiSelectTagItem({
  option,
  clearable = false,
}: MultiSelectTagItemProps) {
  const { removeKey } = useComboBox();
  const onDeleteItem = useCallback(() => {
    removeKey(option.value);
  }, [option.value, removeKey]);

  return (
    <TagBeautified color={option.color}>
      <TagLabel>
        <Typography variant="supportingMediumS">{option.label}</Typography>
      </TagLabel>
      {clearable && <TagDeleteIcon onClick={onDeleteItem} />}
    </TagBeautified>
  );
}
